import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions, authSelectors } from '../modules/auth';

export default function PasskeySetupPrompt({ open }) {
    const dispatch = useDispatch();
    const pendingRedirectUrl = useSelector(authSelectors.pendingRedirectUrl);
    const [isLoading, setIsLoading] = useState(false);

    const handleRedirect = () => {
        if (pendingRedirectUrl) {
            dispatch(authActions.setPendingRedirectUrl(null));
            window.location.href = pendingRedirectUrl;
        }
        else {
            setIsLoading(false);
            dispatch(authActions.setPromptPasskeySetup(false));
        }
    };

    const handleSetUp = () => {
        // Persist to sessionStorage so it survives the page reload
        sessionStorage.setItem('passkeyEnrollmentOptional', 'true');
        dispatch(authActions.setPasskeyEnrollmentOptional(true));
        window.location.href = '/auth/register?fromSettings=false&enrollPasskey=true';
    };

    const handleNotNow = () => {
        setIsLoading(true);
        // Don't close the modal - keep the backdrop up until redirect completes
        handleRedirect();
    };

    const handleDontAskAgain = () => {
        setIsLoading(true);
        dispatch(authActions.skipPasskeySetup())
            .unwrap()
            .then(() => {
                // Don't close the modal - keep the backdrop up until redirect completes
                handleRedirect();
            })
            .catch(() => {
                // Error is already handled by Redux, just stop loading
                setIsLoading(false);
            });
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={(_event, reason) => {
                    // Prevent closing on backdrop click or escape key
                    // User must explicitly choose an action
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    handleNotNow();
                }}
                fullWidth
                disablePortal={false}
                sx={{ zIndex: 9999 }}
                BackdropProps={{
                    sx: {
                        // Hide Dialog's backdrop when loading to prevent double backdrop
                        opacity: isLoading ? 0 : undefined
                    }
                }}
            >
                <DialogTitle>Set up Passkey</DialogTitle>

                <DialogContent>Would you like to set up a passkey for a faster and more secure login?</DialogContent>

                <DialogActions>
                    <Button onClick={handleDontAskAgain} disabled={isLoading}>Don't ask again</Button>
                    <Button onClick={handleNotNow} disabled={isLoading}>Not now</Button>
                    <Button onClick={handleSetUp} disabled={isLoading}>Set up Passkey</Button>
                </DialogActions>
            </Dialog>

            <Backdrop
                open={isLoading}
                sx={(theme) => ({
                    color: theme.palette.primary.main,
                    zIndex: 10000,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                })}
            >
                <CircularProgress color="inherit" size={60} />
            </Backdrop>
        </>
    );
}
